/**
 * Root layout — wraps the whole tree in the AuthProvider + FrontDeskProvider and
 * renders the matched route. Both the public auth routes and the gated app shell
 * render under here, so context (operator identity, sign-out, Front Desk view) is
 * available everywhere. The Front Desk flag is read from sessionStorage on boot
 * (default off), so a reload stays in Front Desk view.
 */
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { FrontDeskProvider } from '@/auth/FrontDeskContext';

export function RootLayout() {
  return (
    <AuthProvider>
      <FrontDeskProvider>
        <Outlet />
      </FrontDeskProvider>
    </AuthProvider>
  );
}
